<template>
  <m-content
    class="quick-filter-header"
    padding-xxs
  >
    <div class="_left">
      <div>{{ label }}</div>
      <slot name="op" />
    </div>
    <div class="_right">
      <m-dropdown
        :title="$t('general.actions')"
        placement="topRight"
      >
        <m-btn
          icon="ellipsis"
          hide-border
          fab
          light
          xs
        />
        <template #overlay>
          <m-card
            no-padding
            list
          >
            <m-card-item
              icon="delete"
              :color="colors.red.base"
              @click="emit('delete')"
            >
              {{ $t('quickFilter.delete') }}
            </m-card-item>
            <m-card-item
              icon="funnel"
              @click="emit('addToAdvanced')"
            >
              {{ $t('quickFilter.addToAdvanced') }}
            </m-card-item>
          </m-card>
        </template>
      </m-dropdown>
    </div>
  </m-content>
</template>
<script setup>
import colors from 'shared/colors';

defineProps({
  label: {
    type: String,
    default: '',
  },
});
const emit = defineEmits(['delete', 'addToAdvanced']);
</script>

<style scoped lang="scss" type="text/scss">
.quick-filter-header {
  display: flex;
  justify-content: space-between;

  ._left {
    display: flex;
    gap: .4rem;
  }
}
</style>
